import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Notification {
  id: string;
  message: string;
  createdAt: string;
}

interface NotificationState {
  messages: Notification[];
}

const initialState: NotificationState = {
  messages: [],
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.messages.unshift(action.payload);
    },
    clearNotifications: (state) => {
      state.messages = [];
    },
    clearNotification: (state, action: PayloadAction<string>) => {
      state.messages = state.messages?.filter(
        (notification) => notification.id !== action.payload
      );
    },
  },
});

export const { addNotification, clearNotifications, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;